import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './Tag.module.css.js';
import themeStyles from '../../styles/themes.module.css.js';
import AnimatedLoaderIcon from '../AnimatedLoaderIcon/AnimatedLoaderIcon.js';
import classNames from '../../utils/classNames.js';

const Tag = /*#__PURE__*/ forwardRef(({ label = '', left = null, leftWrapperClassName = null, right = null, theme = 'primary', type = 'button', isFullWidth = false, isFetching = false, isDisabled = false, withHorizontalPadding = true, onClick = ()=>{}, tabIndex = 0, className: classNameProp, labelClassName = null, onMouseDown = ()=>{}, onMouseUp = ()=>{}, onTouchStart = ()=>{}, onTouchEnd = ()=>{}, variant = 'v1' }, ref)=>{
    const isLabel = type === 'label';
    const isVariantV2 = variant === 'v2';
    const className = classNames(themeStyles[`${theme}Theme`], styles[`${theme}Theme`], theme.includes('Inverted') && styles.disabledInverted, isDisabled && styles.disabled, styles.tag, withHorizontalPadding && styles.withHorizontalPadding, isFullWidth && styles.fullWidth, isFetching && styles.fetching, !isLabel && styles.interactive, classNameProp);
    const inner = jsxs(Fragment, {
        children: [
            left && jsx("span", {
                className: classNames(styles.leftWrapper, isVariantV2 && styles.leftWrapperV2, leftWrapperClassName),
                "aria-hidden": "true",
                children: left
            }),
            jsx("span", {
                className: classNames(styles.label, isVariantV2 && styles.hasSmallLabel, labelClassName),
                children: label
            }),
            jsx("span", {
                className: styles.fetchingIconWrapper,
                children: jsx(AnimatedLoaderIcon, {
                    size: "18px"
                })
            }),
            right && jsx("span", {
                className: styles.rightWrapper,
                "aria-hidden": "true",
                children: right
            })
        ]
    });
    return isLabel ? jsx("div", {
        ref: ref,
        className: className,
        children: inner
    }) : jsx("button", {
        ref: ref,
        className: className,
        // eslint-disable-next-line react/button-has-type
        type: type,
        disabled: isDisabled,
        onClick: onClick,
        tabIndex: tabIndex,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        children: inner
    });
});

export { Tag as default };
